import React, { useState } from 'react';
import * as ui from '@digital/ui';
import ptBr from '@app/i18n/ptBR/index';

import { getAllOptionsStatusModuloEconomicoContratado } from '@app/api/statusModuloEconmicoContratado';
import { getAllStatusRequisicaoCompraSeqOptions } from '@app/api/status';
import { CrfPedidoFormulario } from '@app/api/crf/crfContratadoPcm';
import { ETipoFiltroContratado } from '@app/enums/ETipoFiltroContratado';
import { Visibility } from '@app/components/Visibility';

interface IFiltroPedidoMaterial {
    onSearch?: (filtro: CrfPedidoFormulario) => void;
    atualizarTela: () => void;
    tipoDoFiltro: ETipoFiltroContratado;
}

const FiltrosPedidoComponent = ({ onSearch, atualizarTela, tipoDoFiltro }: IFiltroPedidoMaterial) => {
    var trocarDeValor = [true, false];
    const [statusModuloEconomicoContratado] = ui.usePromise(getAllOptionsStatusModuloEconomicoContratado, [], [] as ui.OptionProps[]);
    const [statusRequisicaoCompraSeqOptions] = ui.usePromise(getAllStatusRequisicaoCompraSeqOptions, [], [] as ui.OptionProps[]);

    const [valorInicial, setValorInicial] = useState<CrfPedidoFormulario>({} as CrfPedidoFormulario);
    const [trocarValor, setTrocarValor] = useState<boolean>(trocarDeValor.reverse()[0]);

    const limparFormulario = () => {
        setTrocarValor(!trocarValor);
        const PropFormularioNovo = {
            acronimoAgrupadorFormulario: '',
            codigoCentroCustoFormulario: '',
            nomeCentroCustoFormulario: '',
            numeroCentroCustoFormulario: '',
            codigoAgrupadorFormulario: '',
            codigoContaContabilFormulario: '',
            dataEmissaoOrdemCompraFormulario: '',
            dataPedidoCompraFormulario: '',
            dataRequisicaoCompraFormulario: '',
            nomeContaContabilFormulario: '',
            nomeFornecedorPedidoCompraFormulario: '',
            nomeProjetoFormulario: '',
            numeroCentroDeCustoFormulario: '',
            numeroItemRequisicaoCompraFormulario: '',
            numeroOrdemCompraFormulario: '',
            numeroPedidoCompraFormulario: '',
            numeroRequisicaoCompraFormulario: '',
            statusModuloEconomicoFormulario: [],
            statusRequisicaoCompraFormulario: [],
            tipoPedidoCompraFormulario: '',
            numeroContratoPcsFormulario: ''
        } as CrfPedidoFormulario;

        setValorInicial(PropFormularioNovo);
        atualizarTela();
    };

    return (
        <ui.MasterDetailForm
            key="filtroPesquisa"
            initialValues={valorInicial}
            onSubmit={onSearch}>
            <ui.FilterWidget
                title="FILTROS DE PESQUISA"
                actions={[
                    <ui.Button
                        type="link"
                        title="Limpar"
                        onClick={() => {
                            limparFormulario();
                        }}
                    />,
                    <ui.FormSubmitButton icon={'commons-search'}>Pesquisar</ui.FormSubmitButton>,
                ]}>
                <div className="ant-row">
                    <ui.FormInput
                        name="numeroCentroCustoFormulario"
                        id="numeroCentroCustoFormulario"
                        label={ptBr.numCentroDeCusto}
                        span={3}
                        allowClear
                    />

                    <ui.FormInput
                        name="codigoCentroCustoFormulario"
                        id="codigoCentroCustoFormulario"
                        label={ptBr.codCentroDeCusto}
                        span={3}
                        allowClear
                    />

                    <ui.FormInput
                        name="nomeCentroCustoFormulario"
                        id="nomeCentroCustoFormulario"
                        label={ptBr.nomeCentroDeCusto}
                        span={3}
                        allowClear
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item: any) => {
                            return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="statusModuloEconomicoFormulario"
                        id="statusModuloEconomicoFormulario"
                        label={ptBr.statusCadastrado}
                        options={statusModuloEconomicoContratado}
                        span={3}
                        allowClear
                    />
                </div>

                <div className="ant-row">
                    <ui.FormInput
                        name="acronimoAgrupadorFormulario"
                        id="acronimoAgrupadorFormulario"
                        label={ptBr.acronimoAgrupador}
                        span={3}
                        allowClear
                    />

                    <ui.FormInput
                        name="codigoAgrupadorFormulario"
                        id="codigoAgrupadorFormulario"
                        label={ptBr.codAgrupador}
                        span={3}
                        allowClear
                    />

                    <ui.FormInput
                        name="codigoContaContabilFormulario"
                        id="codigoContaContabilFormulario"
                        label={ptBr.contaContabil}
                        span={3}
                        allowClear
                    />
                </div>

                <div className="ant-row">
                    <ui.FormNumber
                        name="numeroRequisicaoCompraFormulario"
                        id="numeroRequisicaoCompraFormulario"
                        label={ptBr.numeroRequisicaoDeCompra}
                        span={3}
                    />
                    <ui.FormNumber
                        name="numeroItemRequisicaoCompraFormulario"
                        id="numeroItemRequisicaoCompraFormulario"
                        label={ptBr.itemRequisicaoCompra}
                        span={3}
                    />

                    <ui.FormDatePicker
                        name="dataRequisicaoCompraFormulario"
                        id="dataRequisicaoCompraFormulario"
                        label={ptBr.dataRequisicaoCompra}
                        span={3}
                        format="DD/MM/YYYY"
                        allowClear
                    />

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item: any) => {
                            return item.props.children.props.id.toString().toLowerCase().includes(input.toLowerCase());
                        }}
                        mode="multiple"
                        name="statusRequisicaoCompraFormulario"
                        id="statusRequisicaoCompraFormulario"
                        label={ptBr.statusRequisicaoCompra}
                        options={statusRequisicaoCompraSeqOptions}
                        span={3}
                        allowClear
                    />
                </div>

                <div className="ant-row">
                    <ui.FormInput
                        name="numeroOrdemCompraFormulario"
                        id="numeroOrdemCompraFormulario"
                        label={ptBr.numeroOrdemDeCompra}
                        span={3}
                        allowClear
                    />
                    <ui.FormDatePicker
                        name="dataEmissaoOrdemCompraFormulario"
                        id="dataEmissaoOrdemCompraFormulario"
                        label={ptBr.dataEmissaoOrdemDeCompra}
                        span={3}
                        format="DD/MM/YYYY"
                        allowClear
                    />
                </div>

                <div className="ant-row">
                    <ui.FormNumber
                        name="numeroPedidoCompraFormulario"
                        id="numeroPedidoCompraFormulario"
                        label="N° Pedido"
                        span={3}
                    />
                    <ui.FormInput
                        name="tipoPedidoCompraFormulario"
                        id="tipoPedidoCompraFormulario"
                        label="Tipo Pedido"
                        span={3}
                        allowClear
                    />
                    <ui.FormInput
                        name="nomeFornecedorPedidoCompraFormulario"
                        id="nomeFornecedorPedidoCompraFormulario"
                        label="Nome Fornecedor"
                        span={3}
                        allowClear
                    />
                    <ui.FormDatePicker
                        name="dataPedidoCompraFormulario"
                        id="dataPedidoCompraFormulario"
                        label="Data do Pedido"
                        span={3}
                        format="DD/MM/YYYY"
                        allowClear={true}
                    />
                </div>

                <Visibility
                    visible={tipoDoFiltro == ETipoFiltroContratado.PCS}
                >
                    <div className="ant-row">
                        <ui.FormNumber
                            name="numeroContratoPcsFormulario"
                            id="numeroContratoPcsFormulario"
                            label={ptBr.numeroContratado}
                            span={3}
                        />
                    </div>
                </Visibility>
            </ui.FilterWidget>
        </ui.MasterDetailForm >
    );
};

export default FiltrosPedidoComponent;
